import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ChatPage.css';

const CAMPAIGN_DEADLINE = new Date('2026-04-15T23:59:59');

const NewChatButton = ({ setSelectedProject, setMessages, credit, user_idx }) => {
  const [showPrompt, setShowPrompt] = useState(false);
  const [durationInput, setDurationInput] = useState('');
  const [error, setError] = useState('');
  const [showNoCreditPopup, setShowNoCreditPopup] = useState(false); // new popup state

  // --- KREDİ POPUP GERİ SAYIM STATELERİ ---
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  const navigate = useNavigate();

  const formatDateTR = (date) =>
    date.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' });

  // Kampanya bitiş tarihine kadar geri sayım sayacı
  useEffect(() => {
    // Popup açık değilse sayacı boşuna çalıştırmamak için optimize edilebilir, 
    // ancak şu anki haliyle de oldukça hafif bir işlemdir.
    const countDownDate = CAMPAIGN_DEADLINE.getTime();

    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = countDownDate - now;

      if (distance < 0) {
        clearInterval(timer);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000),
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);
  // ----------------------------------------

  const handleConfirm = () => {
    const duration = parseInt(durationInput, 10);
    if (isNaN(duration) || duration <= 0) {
      setError("Lütfen geçerli sayısal bir ay uzunluğu giriniz.");
      return;
    }

    setSelectedProject({ id: null, duration });
    setMessages([]);
    setShowPrompt(false);
    setDurationInput('');
    setError('');
  };

  const handleCancel = () => {
    setShowPrompt(false);
    setDurationInput('');
    setError('');
  };

  return (
    <>
      <button 
        className="submit-btn small" 
        onClick={() => {
          if (!credit || credit <= 0) {
            setShowNoCreditPopup(true);
            return;
          }
          setShowPrompt(true);
        }}
      >
        Yeni Proje
      </button>

      {showPrompt && (
        <div className="custom-confirm-overlay">
          <div className="custom-confirm-box">
            <p>
              Lütfen, planladığınız proje süresini (toplam uzunluğunu) <strong>ay cinsinden</strong> giriniz.
            </p>
            <input
              type="number"
              value={durationInput}
              onChange={(e) => setDurationInput(e.target.value)}
              placeholder="Örn: 12"
              className="custom-input"
            />
            {error && <p className="error-text">{error}</p>}
            <div className="custom-confirm-buttons">
              <button onClick={handleConfirm}>
                Yeni Proje Oluştur
              </button>
              <button onClick={handleCancel}>
                Geri Dön
              </button>
            </div>
          </div>
        </div>
      )}

      {showNoCreditPopup && (
        <div className="nocredit-popup-overlay">
          <div className="nocredit-confirm-box premium-box">
            
            <div className="nocredit-header">
              <h2>Krediniz Yok</h2>
              <p>Yeni bir projeye başlamak için harika bir zaman!</p>
            </div>
            
            {/* Highlighted Campaign Card */}
            {/*<div className="campaign-highlight">
              <div className="campaign-badge">SON ŞANS • UZATILDI</div>
              <h3>
                Şimdi Sadece <span className="price-tag">25$</span> <span className="vat">+ KDV</span>
              </h3>
              
              
              <div className="time-limit-container">
                <p className="time-limit">
                  ⏳ Kampanya süresi <strong>{formatDateTR(CAMPAIGN_DEADLINE)}</strong> tarihine kadar uzatıldı.
                </p>
                <div className="countdown-timer">
                  <div className="time-box">
                    <span>{timeLeft.days}</span>
                    <small>Gün</small>
                  </div>
                  <span className="colon">:</span>
                  <div className="time-box">
                    <span>{timeLeft.hours.toString().padStart(2, '0')}</span>
                    <small>Saat</small>
                  </div>
                  <span className="colon">:</span>
                  <div className="time-box">
                    <span>{timeLeft.minutes.toString().padStart(2, '0')}</span>
                    <small>Dk</small>
                  </div>
                  <span className="colon">:</span>
                  <div className="time-box">
                    <span>{timeLeft.seconds.toString().padStart(2, '0')}</span>
                    <small>Sn</small>
                  </div>
                </div>
              </div>

            </div>*/}

            <div className="nocredit-confirm-buttons">
              <button 
                className="btn-buy-now" 
                onClick={() => navigate('/buy_credits', { state: { user_idx } })}
              >
                Hemen Fırsatı Yakala
              </button>
              <button 
                className="btn-cancel-nocredit" 
                onClick={() => setShowNoCreditPopup(false)}
              >
                Belki Daha Sonra
              </button>
            </div>

          </div>
        </div>
      )}
    </>
  );
};

export default NewChatButton;